<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>
    
    <v-dialog max-width="75%" v-model="dialogAddEdit" persistent>
      <v-card>
        <v-card-title>
          {{ editedItem.id_concepto_gasto === null ? "Crear" : "Editar" }} Concepto de Gasto REGA's
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.concepto"
                label="Concepto de Gasto REGA's"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="editedItem.facturable"
                :items="opcionesFacturable"
                item-text="text"
                item-value="value"
                label="Facturable"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="editedItem.id_forma_pago"
                :items="formasPago"
                item-text="displayText"
                item-value="id_forma_pago"
                label="Forma de Pago"
                outlined
                dense
                hide-details
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.forma_pago }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.nombre_titular_cuenta }} - SAT: {{ item.clave_sat }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="editedItem.monto_restriccion"
                label="Restricción (Monto Máximo)"
                outlined
                dense
                hide-details
                type="number"
                step="0.01"
                prefix="$"
                hint="Monto total después de impuestos"
                persistent-hint
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogAddEdit" :loading="loadingSave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="65%" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>Eliminar Concepto de Gasto</v-card-title>
        <v-card-text>
          ¿Está seguro de que desea eliminar el concepto "{{ editedItem.concepto }}"? Esta acción es permanente y no se puede revertir.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogDelete" :loading="loadingDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="openDialogAddEdit(null)">
          Crear Concepto de Gasto
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
        >
          <template v-slot:[`item.facturable`]="{ item }">
            {{ item.facturable ? 'Sí' : 'No' }}
          </template>
          <template v-slot:[`item.forma_pago`]="{ item }">
            {{ getFormaPagoDisplay(item.id_forma_pago) }}
          </template>
          <template v-slot:[`item.monto_restriccion`]="{ item }">
            ${{ formatMoney(item.monto_restriccion) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="openDialogAddEdit(item)">
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click="openDialogDelete(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue';

export default {
  components: {
    VAlertDialog
  },
  data: () => ({
    // Configuración para cambiar entre mockup y API real
    useMockup: true, // Cambiar a false para usar API real
    
    dialogAddEdit: false,
    loading: false,
    items: [],
    headers: [
      {
        text: "Concepto de Gasto REGA's",
        value: "concepto",
        align: "center",
        width: "30%"
      },
      {
        text: "Facturable",
        value: "facturable",
        align: "center",
        width: "10%"
      },
      {
        text: "Forma de Pago",
        value: "forma_pago",
        align: "center",
        width: "25%"
      },
      {
        text: "Restricción",
        value: "monto_restriccion",
        align: "center",
        width: "20%"
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "15%"
      }
    ],
    opcionesFacturable: [
      { text: 'Sí', value: true },
      { text: 'No', value: false }
    ],
    formasPago: [
      {
        id_forma_pago: 1,
        forma_pago: "Efectivo",
        id_titular_cuenta: 1,
        nombre_titular_cuenta: "No aplica",
        clave_sat: "01",
        displayText: "Efectivo - No aplica (SAT: 01)"
      },
      {
        id_forma_pago: 2,
        forma_pago: "Cheque nominativo",
        id_titular_cuenta: 2,
        nombre_titular_cuenta: "Un Buen Grupo de Amigos",
        clave_sat: "02",
        displayText: "Cheque nominativo - Un Buen Grupo de Amigos (SAT: 02)"
      },
      {
        id_forma_pago: 3,
        forma_pago: "Transferencia electrónica de fondos",
        id_titular_cuenta: 2,
        nombre_titular_cuenta: "Un Buen Grupo de Amigos",
        clave_sat: "03",
        displayText: "Transferencia electrónica de fondos - Un Buen Grupo de Amigos (SAT: 03)"
      },
      {
        id_forma_pago: 4,
        forma_pago: "Tarjeta débito",
        id_titular_cuenta: 2,
        nombre_titular_cuenta: "Un Buen Grupo de Amigos",
        clave_sat: "28",
        displayText: "Tarjeta débito - Un Buen Grupo de Amigos (SAT: 28)"
      },
      {
        id_forma_pago: 5,
        forma_pago: "Tarjeta débito",
        id_titular_cuenta: 3,
        nombre_titular_cuenta: "Trabajador UBGA autorizado",
        clave_sat: "28",
        displayText: "Tarjeta débito - Trabajador UBGA autorizado (SAT: 28)"
      },
      {
        id_forma_pago: 6,
        forma_pago: "Tarjeta crédito",
        id_titular_cuenta: 3,
        nombre_titular_cuenta: "Trabajador UBGA autorizado",
        clave_sat: "04",
        displayText: "Tarjeta crédito - Trabajador UBGA autorizado (SAT: 04)"
      }
    ],
    editedItem: {
      id_concepto_gasto: null,
      concepto: "",
      facturable: true,
      id_forma_pago: null,
      monto_restriccion: 1990.00
    },
    defaultEditedItem: {
      id_concepto_gasto: null,
      concepto: "",
      facturable: true,
      id_forma_pago: null,
      monto_restriccion: 1990.00
    },
    loadingSave: false,
    dialogDelete: false,
    loadingDelete: false,
    
    // Datos mockup
    mockupData: [
      { id_concepto_gasto: 1, concepto: "Telefonía celular", facturable: true, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 2, concepto: "Protector pantalla celular", facturable: false, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 3, concepto: "Protector celular", facturable: true, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 4, concepto: "Recibos de servicios no facturados", facturable: false, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 5, concepto: "Agua embotellada", facturable: true, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 6, concepto: "Garrafón de agua", facturable: false, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 7, concepto: "Focos", facturable: true, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 8, concepto: "Pintura", facturable: false, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 9, concepto: "Papelería complementaria", facturable: true, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 10, concepto: "Talachas", facturable: false, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 11, concepto: "Casetas (cuando existan tomas de casetas)", facturable: true, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 12, concepto: "Apoyo en comunidad", facturable: false, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 13, concepto: "Taxi (incluye por aplicación)", facturable: true, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 14, concepto: "Camión urbano de transporte", facturable: false, id_forma_pago: 1, monto_restriccion: 1990.00 },
      { id_concepto_gasto: 15, concepto: "Alimentos (viáticos)", facturable: true, id_forma_pago: 1, monto_restriccion: 1990.00 }
    ],
    nextId: 16 // Para generar IDs en el mockup
  }),
  
  mounted() {
    this.getItems();
  },
  
  methods: {
    // ========== MÉTODOS PRINCIPALES (Llaman a mockup o API según configuración) ==========
    getItems() {
      if (this.useMockup) {
        this.getItemsMockup();
      } else {
        this.getItemsAPI();
      }
    },
    
    saveDialogAddEdit() {
      // Validaciones
      if (this.editedItem.concepto == null || this.editedItem.concepto.length === 0 || this.editedItem.concepto.length > 200) {
        this.$refs.alert.setMessage("", "Debe ingresar un Concepto entre 1 y 200 caracteres");
        this.$refs.alert.open();
        return;
      }
      
      if (this.editedItem.facturable == null) {
        this.$refs.alert.setMessage("", "Debe seleccionar si es Facturable");
        this.$refs.alert.open();
        return;
      }
      
      if (this.editedItem.id_forma_pago == null) {
        this.$refs.alert.setMessage("", "Debe seleccionar una Forma de Pago");
        this.$refs.alert.open();
        return;
      }
      
      if (this.editedItem.monto_restriccion == null || this.editedItem.monto_restriccion <= 0) {
        this.$refs.alert.setMessage("", "Debe ingresar un Monto de Restricción válido mayor a 0");
        this.$refs.alert.open();
        return;
      }

      if (this.useMockup) {
        this.saveDialogAddEditMockup();
      } else {
        this.saveDialogAddEditAPI();
      }
    },
    
    saveDialogDelete() {
      if (this.useMockup) {
        this.saveDialogDeleteMockup();
      } else {
        this.saveDialogDeleteAPI();
      }
    },
    
    // ========== MÉTODOS MOCKUP ==========
    getItemsMockup() {
      this.loading = true;
      // Simular delay de API
      setTimeout(() => {
        this.items = [...this.mockupData];
        this.loading = false;
      }, 500);
    },
    
    saveDialogAddEditMockup() {
      this.loadingSave = true;
      
      // Simular delay de API
      setTimeout(() => {
        if (this.editedItem.id_concepto_gasto === null) {
          // Crear nuevo
          const newItem = {
            ...this.editedItem,
            id_concepto_gasto: this.nextId++
          };
          this.mockupData.push(newItem);
        } else {
          // Editar existente
          const index = this.mockupData.findIndex(item => item.id_concepto_gasto === this.editedItem.id_concepto_gasto);
          if (index !== -1) {
            this.mockupData[index] = { ...this.editedItem };
          }
        }
        
        this.getItems();
        this.closeDialogAddEdit();
        this.loadingSave = false;
      }, 800);
    },
    
    saveDialogDeleteMockup() {
      this.loadingDelete = true;
      
      // Simular delay de API
      setTimeout(() => {
        const index = this.mockupData.findIndex(item => item.id_concepto_gasto === this.editedItem.id_concepto_gasto);
        if (index !== -1) {
          this.mockupData.splice(index, 1);
        }
        
        this.closeDialogDelete();
        this.getItems();
        this.loadingDelete = false;
      }, 800);
    },
    
    // ========== MÉTODOS API REAL ==========
    getItemsAPI() {
      this.loading = true;
      axios
        .get('/Catalogos/ListarConceptosGasto')
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    
    saveDialogAddEditAPI() {
      this.loadingSave = true;

      axios({
        method: this.editedItem.id_concepto_gasto === null ? 'POST' : 'PUT',
        url: this.editedItem.id_concepto_gasto === null ? '/Catalogos/CrearConceptoGasto' : `/Catalogos/EditarConceptoGasto/${this.editedItem.id_concepto_gasto}`,
        data: {
          concepto: this.editedItem.concepto,
          facturable: this.editedItem.facturable,
          id_forma_pago: this.editedItem.id_forma_pago,
          monto_restriccion: this.editedItem.monto_restriccion
        }
      })
      .then(() => {
        this.getItems();
        this.closeDialogAddEdit();
      })
      .catch(error => {
        if (error.response && error.response.status == 409) {
          this.$refs.alert.setMessage("", "Ya existe un Concepto de Gasto con el mismo nombre.");
          this.$refs.alert.open();
          return;
        }
        console.log(error);
      })
      .finally(() => {
        this.loadingSave = false;
      });
    },
    
    saveDialogDeleteAPI() {
      this.loadingDelete = true;
      axios
        .delete(`/Catalogos/EliminarConceptoGasto/${this.editedItem.id_concepto_gasto}`)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    },
    
    // ========== MÉTODOS COMUNES ==========
    openDialogAddEdit(editItem = null) {
      if (editItem != null) this.editedItem = Object.assign({}, editItem);
      else this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = true;
    },
    
    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },
    
    openDialogDelete(editItem) {
      this.editedItem = Object.assign({}, editItem);
      this.dialogDelete = true;
    },
    
    closeDialogDelete() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },
    
    // ========== MÉTODOS AUXILIARES ==========
    getFormaPagoDisplay(idFormaPago) {
      const formaPago = this.formasPago.find(fp => fp.id_forma_pago === idFormaPago);
      if (!formaPago) return 'N/A';
      return `${formaPago.forma_pago} - ${formaPago.nombre_titular_cuenta}`;
    },
    
    formatMoney(value) {
      if (value == null) return '0.00';
      return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
  }
}
</script>